import React, { Component } from 'react';
import ApplicationRouter from './ApplicationRouter';
import ApplicationLayout from './ApplicationLayout';
import NoMenuLayout from './components/application/layout/NoMenuLayout';
import AdminLayout from './AdminLayout';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserProfile } from './actions/authentication';
import { authenticatedSelector, currentUserSelector, userFetchedSelector } from './selectors/authentication';
import { isAdminRoute, currentPath } from './selectors/router';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import Loading from './components/helpers/Loading';
import Flash from './components/helpers/Flash';
import { closeFlash } from './actions/global';
import { flashMessageSelector, flashOpenSelector, flashTypeSelector } from './selectors/application';

export const UserContext = React.createContext({});

class Application extends Component {
    componentDidMount() {
        if (this.props.authenticated) {
            this.props.fetchUserProfile();
        }
    }
    render() {
        const Layout = this.props.authenticated ? (this.props.isAdmin ? AdminLayout : ApplicationLayout) : NoMenuLayout;
        const loading = this.props.authenticated && !this.props.userFetched;
        return (
            <UserContext.Provider value={this.props.user}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <React.Fragment>
                        <Flash
                            type={this.props.flashType}
                            message={this.props.flashMessage}
                            open={this.props.flashOpen}
                            onClose={this.props.closeFlash}
                        />
                        {loading ? (
                            <Loading className={'is-full-screen'} />
                        ) : (
                            <div className={`ckp-application-router u-full-height`}>
                                <ApplicationRouter
                                    path={this.props.path}
                                    layout={Layout}
                                    authenticated={this.props.authenticated}
                                    history={this.props.history}
                                />
                            </div>
                        )}
                    </React.Fragment>
                </MuiPickersUtilsProvider>
            </UserContext.Provider>
        );
    }
}

const mapStateToProps = state => ({
    authenticated: authenticatedSelector(state),
    user: currentUserSelector(state),
    userFetched: userFetchedSelector(state),
    isAdmin: isAdminRoute(state),
    path: currentPath(state),
    flashMessage: flashMessageSelector(state),
    flashOpen: flashOpenSelector(state),
    flashType: flashTypeSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ fetchUserProfile, closeFlash }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Application);



// WEBPACK FOOTER //
// ./src/Application.js